import { render, staticRenderFns } from "./BehaviorTypeSlidebar.vue?vue&type=template&id=43fcf4cd"
import script from "./BehaviorTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./BehaviorTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports